/* FAQ Accordion — Expand/collapse with one-at-a-time */
(function() {
  'use strict';

  var accordion = document.querySelector('[data-faq-accordion]');
  if (!accordion) return;

  var items = accordion.querySelectorAll('.faq-accordion__item');

  items.forEach(function(item) {
    var trigger = item.querySelector('.faq-accordion__question');
    if (!trigger) return;

    trigger.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');

      /* Close all others */
      items.forEach(function(other) {
        other.classList.remove('is-open');
        var otherTrigger = other.querySelector('.faq-accordion__question');
        if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
      });

      /* Toggle current */
      if (!isOpen) {
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();
